import {
  List,
  Datagrid,
  TextField,
  EditButton,
  usePermissions,
  FunctionField,
  TextInput,
  SelectInput,
} from "react-admin";

import { Chip } from "@mui/material";

const QuestionList = () => {
  const { permissions = [] } = usePermissions();

  const questionFilters = [
    <TextInput label="Search by title" source="q" alwaysOn />,
    <SelectInput
      label="Difficulty"
      source="difficulty_level"
      choices={[
        { id: "easy", name: "Easy" },
        { id: "medium", name: "Medium" },
        { id: "hard", name: "Hard" },
      ]}
    />,
    <TextInput label="Category" source="category_name" />,
    <TextInput label="Subcategory" source="subcategory_name" />,
  ];

  return (
    <List
      title="Question Bank"
      filters={questionFilters}
      sx={{
        "& .RaDatagrid-row": {
          height: 80,
          borderRadius: "12px",
        },
      }}
    >
      <Datagrid
        sx={{
          "& .RaDatagrid-row": {
            borderRadius: "12px",
            mb: 1,
          },
        }}
      >
        {/* ID */}
        <TextField source="id" />

        {/* TITLE */}
        <TextField source="title" />

        {/* DIFFICULTY as Chip */}
        <FunctionField
          label="Difficulty"
          render={(record) => (
            <Chip
              label={record.difficulty_level}
              size="small"
            />
          )}
        />

        {/* MARKS */}
        <FunctionField
          label="Marks"
          render={(record) => (
            <Chip
              label={record.question_data?.marks || 0}
              size="small"
              
            />
          )}
        />

        {/* CATEGORY */}
        <FunctionField
          label="Category"
          render={(record) => (
            <Chip
              label={record.category_names?.join(", ") || "-"}
              size="small"
              sx={{
                  maxWidth: "180px",
                  height: "auto",

                  "& .MuiChip-label": {
                    display: "block",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                    lineHeight: 1.4,
                    padding: "6px 8px",
                    textWrap: "wrap",
                  },
                }}
              
            />

          )}
        />

        {/* SUBCATEGORY */}
        <FunctionField
          label="Subcategory"
          render={(record) => (
            <Chip
              label={record.subcategory_names?.join(", ") || "-"}
              size="small"sx={{
                  maxWidth: "180px",
                  height: "auto",

                  "& .MuiChip-label": {
                    display: "block",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                    lineHeight: 1.4,
                    padding: "6px 8px",
                    textwrap: "wrap",
                  },
                }}
              
            />
          )}
        />

        {/* EDIT BUTTON */}
        {(permissions.includes("assessments.edit") ||
          permissions.includes("assessments.*") ||
          permissions.includes("*")) && <EditButton />}
      </Datagrid>
    </List>
  );
};

export default QuestionList;